import { hc } from 'hono/client'
import type { AppType } from '../../../server/src/app.js'

/**
 * Typed API client.
 *
 * `AppType` is imported straight from the server's Hono app, so every route,
 * param and response shape is checked at compile time with no codegen step and
 * no duplicated interface definitions. Change a handler's return shape and the
 * component consuming it stops compiling.
 *
 * The import is type-only and erased at build time — no server code ships.
 */
const client = hc<AppType>(typeof window === 'undefined' ? '/' : window.location.origin)

export const api = client.api

/** Narrow helper so callers get a useful message instead of `[object Object]`. */
export async function unwrap<T>(response: {
  ok: boolean
  status: number
  json: () => Promise<T>
}): Promise<T> {
  if (!response.ok) {
    let detail = `Request failed (${response.status})`
    try {
      const body = (await response.json()) as { error?: string }
      if (body?.error) detail = body.error
    } catch {
      // Non-JSON error body; the status line is all we have.
    }
    throw new Error(detail)
  }
  return response.json()
}
